import React, { useCallback } from 'react';
import propTypes from 'prop-types';
;
import { Button, Columns, Column } from 'src/ui/mui-ui-kit';;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function DocumentCardItem({
  document,
  loading,
  onDelete,
  showLink,
  needsApproval,
}) {
  const onDeleteDocument = useCallback(() => {
    onDelete(document);
  }, []);

  return (
    <div className="document-card-item">
      <Columns isGapless isVCentered>
        <Column className="has-text-weight-semibold is-size-7 document-title">
          {document.file && showLink ? (
            <a
              href={document.file}
              target="_blank"
              rel="noopener noreferrer"
              className="has-text-primary"
            >
              {document.title}
            </a>
          ) : (
            <span className="has-text-primary">{document.title}</span>
          )}
        </Column>
        {needsApproval && (
          <Column>
            {document.isApproved ? (
              <div className="has-text-green">
                <span className="icon has-text-green">
                  <FontAwesomeIcon icon={['fal', 'check']} />
                </span>
                Document Approved
              </div>
            ) : (
              <div className="has-text-secondary">
                <span className="icon has-text-secondary">
                  <FontAwesomeIcon icon={['fas', 'spinner']} spin />
                </span>
                Approval Pending
              </div>
            )}
          </Column>
        )}
        {loading === false && (
          <Column isSize="narrow">
            <Button
              isColor="text"
              className="is-rounded"
              onClick={onDeleteDocument}
            >
              <span className="icon has-text-grey-lighter is-medium">
                <FontAwesomeIcon icon={['fal', 'times-circle']} size="lg" />
              </span>
            </Button>
          </Column>
        )}
      </Columns>
      {loading !== false && (
        <progress
          className="progress is-gradient-bright"
          max="100"
          value={loading !== true ? loading : null}
        />
      )}
    </div>
  );
}

DocumentCardItem.defaultProps = {
  loading: false,
  onDelete: () => {},
  showLink: false,
  needsApproval: false,
};

DocumentCardItem.propTypes = {
  document: propTypes.shape({
    title: propTypes.string.isRequired,
    file: propTypes.string,
    isApproved: propTypes.bool,
  }).isRequired,
  loading: propTypes.oneOfType([propTypes.number, propTypes.bool]),
  onDelete: propTypes.func,
  showLink: propTypes.bool,
  needsApproval: propTypes.bool,
};
